import "./index.scss";
import { renderMenuItem } from "./utils/renderMenuItem";

export const MenuOverlay = ({ isLoggedIn, isOpen, onClick, items }) => {
  const openClass = isOpen ? "open" : "closed";

  return (
    <div
      className={`menu-overlay ${openClass}`}
      onClick={onClick}
      data-testid="menu"
    >
      <div className="menu">
        <ul>{items.map((item) => renderMenuItem(isLoggedIn, item))}</ul>
      </div>
      <div className="backdrop" />
    </div>
  );
};
